module.exports = __webpack_public_path__ + "static/media/17.cb3b4053.JPG";